module.exports = __webpack_public_path__ + "static/media/uor_logo.d8a61d45.svg";